import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TokenListUidCell } from './token-list-uid.cell';
import { TokenListUidHeader } from './token-list-uid.header';

export const TokenListUidColumn: IdentifiedColumnDef<
  GatewayTokenModel,
  GatewayTokenModel['uid']
> = {
  enableSorting: false,
  header: TokenListUidHeader,
  cell: TokenListUidCell,
};
